<script>
import { posthog } from 'posthog-js'
import { convertCurrency } from '~/assets/js/methods'
import FormCheckout from '~/components/FormCheckout.vue'
import Spinner from '~/components/Spinner.vue'
import Top from '~/components/Top.vue'
import CardSecurity from '~/components/CardSecurity.vue'
import CartItems from '~/components/CartItems.vue'
import CartItemsDesktop from '~/components/CartItemsDesktop.vue'
import CountDown from '~/components/CountDown.vue'
import InitGatewaysScript from '~/components/InitGatewaysScript.vue'
import Orderbump from '~/components/Orderbump.vue'
import Steps from '~/components/Steps.vue'
import Sumary from '~/components/Sumary.vue'
import PageLayout from '~/components/yampi/PageLayout.vue'
import SinglePageLayout from '~/components/singlepage/SinglePageLayout.vue'

const Events = () => import('~/components/Events.vue')
const Sidebar = () => import('~/components/Sidebar.vue')
const Bonus = () => import('~/components/Bonus.vue')
const Footer = () => import('~/components/Footer.vue')

// Ao usar o layout default, precisa descomentar o Tailwindcss no Layout Default
export default {
    name: 'Index',
    layout: 'yampi',
    components: {
        Top,
        FormCheckout,
        Sidebar,
        CardSecurity,
        Events,
        Bonus,
        Spinner,
        Footer,
        CountDown,
        Steps,
        CartItems,
        CartItemsDesktop,
        Orderbump,
        Sumary,
        PageLayout,
        SinglePageLayout,
        InitGatewaysScript,
    },
    setup() {
        return {
            convertCurrency,
        }
    },
    fetchOnServer: false,
    async fetch() {
        if (process.client === true) {
            let page = this.$route.params.page
            let multiple = this.$route.query.multiple
            let customer_hash = this.$route.query.ch ?? ''
            let platform = this.$route.query.platform ?? ''
            
            const domain = (window.location.hostname !== 'localhost') ? window.location.hostname : '';

            let endpoint = `/checkout/${page}/product?multiple=${multiple}&ch=${customer_hash}&domain=${domain}`;

            if (platform && ['shopify', 'woocommerce'].includes(platform)) {
                endpoint += `&platform=${platform}`;
            }

            const result = await this.$axios.get(endpoint)
            
            if (result.status !== 200) {
                posthog.capture('Error', { msg: result.statusText })
            }

            this.showSpinner = false

            const response = result.data
            try {
                this.product_status = response.product[0].status
                this.product_tangible = response.product[0].product.tangible
                this.$store.commit('setProduct', response.product[0] ?? '')
                this.$store.commit('setCompanyName', response.company_name ?? '')
                this.$store.commit('setCompanyDomain', response.company_domain ?? '')
                this.$store.commit('setKlaviyoKey', response.klaviyo_api_key ?? '')
                this.$store.commit('setStore', response.store ?? '')
                this.$store.commit(
                    'setCustomCheckout',
                    response.custom_checkout ?? ''
                )
                this.$store.commit(
                    'setTestimonials',
                    response.testimonials ?? ''
                )
                this.$store.commit(
                    'setCustomFormCheckouts',
                    response.custom_form_checkouts ?? ''
                )

                this.$store.commit('setPixels', response.pixels ?? '')
                this.$store.commit('setDatalayerModel', response.datalayer_format ?? '')
                this.$store.commit('setOrderBumps', response.orderbumps ?? '')
                this.$store.commit('setPaymentMethods', ['1', '2', '3'])

                this.$store.commit('setGateway', response.gateways ?? [])
                this.$store.commit(
                    'setGatewaysRetry',
                    response.gateways_retry ?? []
                )
                this.$store.commit(
                    'setLogisticsShippings',
                    response.shippings ?? []
                )

                if (response.max_upsell_shopify_discount) {
                    this.$store.commit('setMaxUpsellShopify', response.max_upsell_shopify_discount);
                }

                this.customerData = response.customer ?? null

                let cartStorage =
                    localStorage.getItem('cart') || JSON.stringify([])

                cartStorage = JSON.parse(cartStorage)

                if (cartStorage.length > 0) {
                    localStorage.removeItem('cart')
                }

                this.$nextTick(() => {
                    response.product.forEach((v, k) => {
                        v.custom_options = [];
                        if (typeof this.$route.query.custom_options !== 'undefined') {
                            try {
                                let custom_fields = this.$route.query.custom_options.split('::');
                                
                                custom_fields.forEach((customField) => {
                                    let customFieldData = customField.split(':-:');
                                    if (v.shopify_variation_id === parseInt(customFieldData[0])) {
                                        try {
                                            let customOptionData = JSON.parse(customFieldData[1]);
                                            if(Object.keys(customOptionData).length === 0) {
                                                return;
                                            }
                                            
                                            if (customOptionData['__essential_upsell_funnel_id'] && customOptionData['discounted_price']) {
                                                let discounted_price = parseFloat(customOptionData['discounted_price']);
                                                v.upsell_shopify_discount = discounted_price;
                                            }
                                            
                                            let customOptionExists = v.custom_options.find(option => 
                                                JSON.stringify(option, (key, value) => typeof value === 'string' ? value.trim() : value) === 
                                                JSON.stringify(customOptionData, (key, value) => typeof value === 'string' ? value.trim() : value)
                                            );

                                            if (customOptionExists) {
                                                customOptionExists.quantity = (customOptionExists.quantity || 1) + 1;
                                            } else {
                                                let newCustomOption = Object.fromEntries(
                                                    Object.entries(customOptionData).filter(([key, value]) => value !== null && value !== '')
                                                );
                                                newCustomOption.quantity = 1;
                                                v.custom_options.push(newCustomOption);
                                            }
                                        } catch (parseError) {
                                            console.error("Erro ao analisar custom_options:", parseError);
                                        }
                                    }
                                });

                            } catch (error) {
                                console.error("Erro ao processar custom_options:", error);
                            }
                        }

                        const urlParams = window.location.search;
                        const quantitys = urlParams.split('&qtds=')[1] ? urlParams.split('&qtds=')[1].split(',') : null;

                        this.$store.commit('setCartItem', {
                            cartvar: `${v.variation_hash}_1`,
                            id: v.id,
                            store_id: v.store_id,
                            hash: v.variation_hash,
                            variation_id: v.variation_id,
                            shopify_product_id: v.shopify_product_id,
                            shopify_variation_id: v.shopify_variation_id,
                            woocommerce_product_id: v.woocommerce_product_id,
                            woocommerce_variation_id: v.woocommerce_variation_id,                            
                            custom_options: v.custom_options,  
                            sku: v.sku,
                            product_hash: v.hash,
                            product_id: v.product_id,
                            title: v.title,
                            variation_title: v.variation_title,
                            cover: v.variation_image ?? v.cover,
                            price: parseInt(v.sale_price),
                            offer_price: parseInt(v.price),
                            quantity: quantitys && quantitys.length > 0 ? quantitys[k] : (v.quantity ?? 1),
                            operation_type: 1,
                        });
                    });
                });


                this.$store.commit(
                    'setInstallments',
                    response.custom_checkout.default_installments
                )

                this.$store.commit('setTracking', {
                    src: this.$route.query.src ?? '',
                    utm_source: this.$route.query.utm_source ?? '',
                    utm_medium: this.$route.query.utm_medium ?? '',
                    utm_campaign: this.$route.query.utm_campaign ?? '',
                    utm_term: this.$route.query.utm_term ?? '',
                    utm_content: this.$route.query.utm_content ?? '',
                })

                this.$store.commit('setEventsState', { InitiateCheckout: true })
                console.log(process.env.NODE_ENV)
            } catch (error) {
                console.error(error)

                fetch(
                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                    {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            title: `Page Error after Fetch`,
                            message: `${error}`,
                            sound: 'mechanical',
                        }),
                    }
                )
            }
        }
    },
    computed: {
        firstStepValid() {
            return this.$store.getters['firstStepValid']
        },
        getCustomCheckout() {
            return this.$store.getters['getCustomCheckout']
        },
    },
    watch: {
        firstStepValid: {
            handler(e) {
                if (e === true) {
                    this.isFirstStepValid = e
                }
            },
        },
        getCustomCheckout: {
            handler(e) {
                if (e.template_mode_is_single === 1 || e.template_mode_is_single === 0) {
                    this.template = 'yampi'
                } else {
                    this.template = 'oneStep'
                }
            },
            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            product_status: '',
            offer: '',
            isFirstStepValid: '',
            showSpinner: '',
            template: 'yampi',
            customerData: '',
        }
    },
    head() {
        return {
            title: 'Finalize sua compra agora!',
            link: [
                {
                    hid: 'icon',
                    rel: 'icon',
                    type: 'image/x-icon',
                    href:
                        this.$store.getters['getCustomCheckout'].favicon ?? '',
                },
            ],
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$nuxt.$loading.start()
            this.showSpinner = true


        })
    },
}
</script>

<template>
    <div class="bg-gray-200">
        <InitGatewaysScript />
        <Spinner v-if="showSpinner && template !== 'yampi'" />
        <div v-if="$fetchState.pending"></div>
        <div v-else-if="$fetchState.error">
            Ocorreu um erro ao tentar abrir a página. Atualize a página
            novamente.
        </div>
        <div v-else>
            <div v-if="product_status == 1 ||
                product_status == 'active' ||
                product_status == 'draft'
                ">
                <Events />
                <PageLayout v-if="template === 'yampi'" :customerData="customerData" />
                <SinglePageLayout v-else :customerData="customerData" />
                
                <div v-else>
                    <!-- <CountDown /> -->
                    <Top />
                    <section>
                        <div class="container mx-auto py-2">
                            <div class="flex flex-wrap max-w-4xl mx-auto">
                                <div class="w-full px-3 lg:w-7/12 xl:w-8/12">
                                    <!-- <Steps /> -->
                                    <CartItems />
                                    <FormCheckout />
                                </div>

                                <div class="w-full px-3 lg:w-5/12 xl:w-4/12">
                                    <CartItemsDesktop />
                                    <CardSecurity />
                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- <Footer /> -->
                </div>
            </div>
        </div>
    </div>
</template>

<style>
html {
    --scroll-behavior: smooth;
    scroll-behavior: smooth;
}
</style>
